import styled from '@emotion/styled';
import { FC } from 'react';

import { Colors } from '@/assets';

const StyleControl = styled.div`
    .range {
        border-radius: 8px;
        height: 2px;
        width: 100%;
        outline: none;
        transition: background 450ms ease-in;
        -webkit-appearance: none;
        cursor: pointer;
    }
    .range::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        box-sizing: border-box;
        border-radius: 90px;
        cursor: pointer;
        background-clip: padding-box;
        width: 37px;
        height: 18px;
        transform: scale(2);
        position: absolute;
        top: -1px;
        margin-left: -1px;
        border: 1px solid ${Colors.geyserGrey};
    }
    .range:active::-webkit-slider-thumb {
        opacity: 0;
    }
    .range::-webkit-slider-thumb:hover {
        border-color: ${Colors.vividTangerineOrange};
    }
`;

export const AppSlider: FC = ({ children }) => {
    return <StyleControl>{children}</StyleControl>;
};
